import { render } from "./ShapeSetting.vue?vue&type=template&id=707b5db1"
import script from "./ShapeSetting.vue?vue&type=script&lang=js"
export * from "./ShapeSetting.vue?vue&type=script&lang=js"

import "./ShapeSetting.vue?vue&type=style&index=0&id=707b5db1&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__